import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, Organization, AuthUser, OrgMember } from '../../types/models';

interface AuthState {
  isAuthenticated: boolean;
  authUser: AuthUser | null;
  user: User | null;
  organization: Organization | null;
  members: OrgMember[];
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  authUser: null,
  user: null,
  organization: null,
  members: [],
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setAuthUser: (state, action: PayloadAction<AuthUser | null>) => {
      state.authUser = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setOrganization: (state, action: PayloadAction<Organization | null>) => {
      state.organization = action.payload;
    },
    signInSuccess: (state, action: PayloadAction<{ authUser: AuthUser; user: User; organization?: Organization }>) => {
      state.isAuthenticated = true;
      state.authUser = action.payload.authUser;
      state.user = action.payload.user;
      state.organization = action.payload.organization || null;
      state.loading = false;
      state.error = null;
    },
    setMembers: (state, action: PayloadAction<OrgMember[]>) => {
      state.members = action.payload;
    },
    signOutSuccess: (state) => {
      state.isAuthenticated = false;
      state.authUser = null;
      state.user = null;
      state.organization = null;
      state.members = [];
      state.loading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setAuthUser,
  setUser,
  setOrganization,
  setMembers,
  signInSuccess,
  signOutSuccess,
  clearError,
} = authSlice.actions;

export default authSlice.reducer;